<template>
  <div class="popup">
    <div class="popup__wrap">
      <div class="popup__bg" :class="{ 'popup__bg--white': showDefaultPrice }" @click.stop="onClosePopup()"></div>
      <div class="popup__container" :class="{ border: showDefaultPrice }" :style="{ 'max-width': maxWidth + 'px' }">
        <button class="popup__btn-close" @click="onClosePopup()">
          <IconClose />
        </button>
        <div class="popup__top">
          <div class="popup__top-title" v-if="title">
            {{ title }}
          </div>
          <h4 v-if="secondTitle" class="popup__sub-title">{{ secondTitle }}</h4>
        </div>
        <div class="popup__content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import IconClose from '@/components/icons/IconClose.vue';

export default {
  name: 'popup-wrap',
  components: { IconClose },
  props: {
    title: {},
    secondTitle: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: Number,
      default: 860
    },
    backgroundHide: {
      type: Boolean,
      default: () => false
    }
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      showDefaultPrice: 'popups/showDefaultPrice'
    })
  },
  methods: {
    onClosePopup() {
      document.getElementById('html').classList.remove('hide');
      this.$emit('close-popup');
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/vars';
@import '@/assets/scss/mixins';

.popup {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 50;
  overflow-y: auto;

  &__sub-title {
    font-weight: 400;
    font-size: 32px;
    line-height: 39px;
    text-transform: uppercase;
    margin: 0;
    color: $color-black;
  }

  &__bg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);

    &--white {
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        filter: blur(3px);
        opacity: 0.96;
        background-color: $color-white;
      }
    }
  }

  &__wrap {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;
    overflow-y: auto;
  }

  &__container {
    margin-top: 36px;
    margin-bottom: 36px;
    width: 100%;
    max-width: 840px;
    background: $color-white;
    padding: 32px 32px 24px;
    position: relative;
    z-index: 2;

    &.border {
      border: 1px solid $color-prototype;
    }
  }

  &__btn-close {
    position: absolute;
    right: 12px;
    top: 12px;
    padding: 0;
    width: 30px;
    height: 30px;

    svg {
      width: 30px;
      height: 30px;
    }
  }

  &__content {
  }

  &__top {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;

    &-title {
      padding-bottom: 16px;
      width: 100%;
      max-width: 100%;
      text-align: center;
      margin-top: 35px;
      font-weight: 400;
      font-size: 24px;
      line-height: 29px;
      color: $color-black;
    }
  }
}

@media screen and (max-width: 1024px) {
  .popup {
    &__bg {
      position: fixed;
    }
  }
}

@media screen and (max-width: 640px) {
  .popup {
    &__btn-close {
      top: 8px;
      right: 8px;
    }

    &__container {
      max-width: calc(100% - 16px) !important;
      width: 100%;
      margin: 16px auto;
      padding: 24px 16px 16px;
    }

    &__top-title {
      padding-bottom: 8px;
      font-size: 16px;
    }
  }
}
</style>
